import styled from 'styled-components';
import { DarkSlateBlue } from '../../../../theme/colors';
import fptLogo from '../../../../assets/images/driver-small-logo.svg';
export { Fullscreen } from './Screen';

export const ContentPanel = styled.div`
  flex: auto;
  text-align: center;
  padding: 0 0 140px;

  &.fpt-show {
    display: block;
  }

  &.fpt-hide {
    display: none;
  }
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 30px 0;
  width: 100%;
`;

export const Section = styled.div`
  margin: 16px 50px 0;

  &.fpt-hide {
    display: none;
  }
`;

export const FptLogo = styled.img.attrs((props) => ({
  ...props,
  src: fptLogo,
  alt: 'Footprint',
  className: '',
}))`
  margin: 0 auto;
  width: 40px;
  vertical-align: middle;
`;
